import { ImgProps } from "assets/images/types";

export default function ImgNatura(props: ImgProps) {
	const { height = 45, width = 60 } = props;
	return (
		<img
			src="/assets/images/companies/natura.webp"
			alt="Natura logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
